// dom.js — kleine DOM-Helfer.
export const $ = (sel, root = document) => root.querySelector(sel);
export const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

/** Delegiertes Event: on(root, 'click', '[data-act="save"]', (e, el) => …). Gibt eine Abmeldefunktion zurück. */
export function on(root, type, selector, fn, opts) {
  const h = (e) => {
    const el = e.target instanceof Element ? e.target.closest(selector) : null;
    if (el && root.contains(el)) fn(e, el);
  };
  root.addEventListener(type, h, opts);
  return () => root.removeEventListener(type, h, opts);
}

/** Ein Element mit Attributen/Kindern erzeugen (für Fälle, in denen kein Template passt). */
export function el(tag, props = {}, ...children) {
  const n = document.createElement(tag);
  for (const [k, v] of Object.entries(props)) {
    if (v == null || v === false) continue;
    if (k === 'class') n.className = v;
    else if (k === 'dataset') Object.assign(n.dataset, v);
    else if (k.startsWith('on') && typeof v === 'function') n.addEventListener(k.slice(2), v);
    else if (v === true) n.setAttribute(k, '');
    else n.setAttribute(k, v);
  }
  for (const c of children.flat()) if (c != null && c !== false) n.append(c instanceof Node ? c : String(c));
  return n;
}

/** Fenstergrößenklasse nach M3 (compact/medium/expanded/large/xl). */
export const WINDOW_CLASSES = [['compact', 0], ['medium', 600], ['expanded', 840], ['large', 1200], ['xl', 1600]];
export function windowClass(width = window.innerWidth) {
  let c = 'compact';
  for (const [name, min] of WINDOW_CLASSES) if (width >= min) c = name;
  return c;
}
export const atLeast = (cls, current = windowClass()) =>
  WINDOW_CLASSES.findIndex(([n]) => n === current) >= WINDOW_CLASSES.findIndex(([n]) => n === cls);

export const reducedMotion = () => document.documentElement.dataset.motion === 'reduced'
  || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
